import { useFeatureGate } from '@statsig/expo-bindings';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Spinner, View } from 'smoothie';

import { FeatureFlags } from '../../../../feature-flags/FeatureFlags';
import { useMoneyMapWorkflow } from '../../../hooks/useMoneyMapWorkflow';
import { GoWorkflowStepType } from '../../../types/GoWorkflow';
import { GoWorkflowHeader } from '../../GoWorkflowHeader';
import ProposedIncomeSplit from './ProposedIncomeSplit';
import ProposedIncomeSplitLegacy from './ProposedIncomeSplitLegacy';

const ProposedIncomeSplitContainer = () => {
    const { value: enableTiedRules } = useFeatureGate(
        FeatureFlags.ENABLE_TIED_RULES,
    );

    const [hasNewMoneyMap, setHasNewMoneyMap] = useState(false);

    const { isLoadingMoneyMap, moneyMap } = useMoneyMapWorkflow();

    useEffect(() => {
        setHasNewMoneyMap((moneyMap?.moneyMapRuleGroups ?? []).length > 0);
    }, [moneyMap]);

    return (
        <View flex={1}>
            <GoWorkflowHeader
                stepType={GoWorkflowStepType.INCOME_SPLIT}
                title="Income Split"
                hasMessagingButton={false}
            />
            {isLoadingMoneyMap ? (
                <Spinner />
            ) : enableTiedRules || hasNewMoneyMap ? (
                <ProposedIncomeSplit />
            ) : (
                <ProposedIncomeSplitLegacy />
            )}
        </View>
    );
};

export default ProposedIncomeSplitContainer;
